$("#orders").on('click', function(){
  try{
  	window.PlobalBridge.redirectTo('orderlistscreen');
  } catch(err){
  	console.log(err);
  }
});

$("#wishlist").on('click', function(){
  try{
  	window.PlobalBridge.redirectTo('wishlistscreen');
  } catch(err){
  	console.log(err);
  }
});

$("#addresses").on('click', function(){
  try{
  	window.PlobalBridge.redirectTo('addressscreen');
  } catch(err){
  	console.log(err);
  }
});

$("#logout").on('click', function(){
  try{
  	window.PlobalBridge.redirectTo('dologout');
  } catch(err){
  	console.log(err);
  }
});

$("#product").on('click', function(){
  try{
    var product_id = "roadster-skinny-fit-womens-jeans";
    var title = "roadster-skinny-fit-womens-jeans";
    var product_url = "https://plobal-test-dashboard.myshopify.com/collections/brands/products/roadster-skinny-fit-womens-jeans";
  	window.PlobalBridge.openProductDetail(product_id, title, product_url);
  } catch(err){
  	console.log(err);
  }
});

$("#logout-bridge").on('click', function(){
  try{
    window.PlobalBridge.callBridgeFunction('doLogout', null, null);
  } catch(err){
  	console.log(err);
  }
});